import axios from "axios";
import Cookies from "universal-cookie";
// const apiUrl = process.env.REACT_APP_API_URL;

const cookies = new Cookies();
export const getUserApi = async (
  searchTerm: string,
  url: string
): Promise<any> => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(`${url}/login/GetUser`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        searchTerm: searchTerm,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    return false;
  }
};

export const getUserByRoleType = async (
  roleType: number,
  url: string
): Promise<any> => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(
      `${url}/user/GetUserByRoleType?roleType=${roleType}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateUserApi = async (
  url: string,

  id: string,
  name: string,
  email: string,
  mobile: string,
  address: string,
  roleType: string,
  gender: number
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/login/updateuser`,
      {
        Id: id,
        Name: name,
        Email: email,
        Mobile: mobile,
        Address: address,
        RoleType: Number(roleType),
        Gender: Number(gender),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchUserByIdApi = async (url: string, userId: string) => {
  const cookies = new Cookies();
  const token = cookies.get("authToken");

  try {
    const response = await axios.get(`${url}/login/getuserbyid/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching user by ID:", error);
    return false;
  }
};

export const addUserApi = async (
  url: string,
  name: string,
  email: string,
  mobile: string,
  address: string,
  roleType: string,
  gender: string
) => {
  const token = cookies.get("authToken");

  try {
    const response = await axios.post(
      `${url}/login/adduser`,
      {
        Name: name,
        Email: email,
        Mobile: mobile,
        Address: address,
        RoleType: Number(roleType),
        Gender: Number(gender),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error(error);

    throw error;
  }
};
